import { createAction } from "@ngrx/store";
import { Deal } from "../../shared/models/deal.model";
import { DealsQueryParams } from "../../shared/services/api/deal-operations.service";
import { payload } from "../shared/utils/ngrx-creators";

createAction('[Portfolios] Init Portfolios');

export const loadPortfolios = createAction(
  '[Portfolios] Load Portfolios',
  payload<{ params?: DealsQueryParams }>()
);

export const loadPortfoliosFail = createAction('[Portfolios] Load Portfolios Fail');

export const loadPortfoliosSuccess = createAction(
  '[Portfolios] Load Portfolios Success',
  payload<{ portfolios: Deal[], total: number, totalPages?: number }>()
);

export const loadPortfolioDetails = createAction(
  '[Portfolios] Load Portfolios Details',
  payload<{ code: string }>()
);

export const loadPortfolioDetailsFail = createAction('[Portfolios] Load Portfolio Details Fail');

export const loadPortfolioDetailsSuccess = createAction(
  '[Portfolios] Load Portfolio Details Success',
  payload<{ portfolio: Deal }>()
);

export const clearPortfolios = createAction('[Portfolios] Clear Portfolios');
